var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center mt-2 mb-10 flex-col items-center"},[_vm._v(" "+_vm._s(_vm.queryForDisplay)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }